import React from 'react';
import { HashRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import NotFound from './pages/common/NotFound';
import Login from './pages/common/Login';
import App from './App';

export default () => (
    <Router>
        <Switch>
            <Route exact path="/">
                <Redirect to="/app/dashboard/index" />
            </Route>
            <Route path="/app" component={App} />
            <Route path="/404" component={NotFound} />
            <Route path="/login" component={Login} />
            <Route component={NotFound} />
        </Switch>
    </Router>
);
